/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalAuthSubmissionErrorType = {
    RemotePatientNotFound: 'REMOTE_PATIENT_NOT_FOUND',
    OrderingFacilityNotFound: 'ORDERING_FACILITY_NOT_FOUND',
    OrderingPhysicianNotFound: 'ORDERING_PHYSICIAN_NOT_FOUND',
    ServicingFacilityNotFound: 'SERVICING_FACILITY_NOT_FOUND',
    AttendingPhysicianNotFound: 'ATTENDING_PHYSICIAN_NOT_FOUND',
    InternalError: 'INTERNAL_ERROR'
} as const;
export type PalAuthSubmissionErrorType = typeof PalAuthSubmissionErrorType[keyof typeof PalAuthSubmissionErrorType];


export function PalAuthSubmissionErrorTypeFromJSON(json: any): PalAuthSubmissionErrorType {
    return PalAuthSubmissionErrorTypeFromJSONTyped(json, false);
}

export function PalAuthSubmissionErrorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionErrorType {
    return json as PalAuthSubmissionErrorType;
}

export function PalAuthSubmissionErrorTypeToJSON(value?: PalAuthSubmissionErrorType | null): any {
    return value as any;
}

